export enum YesNoNa {
	No = 0,
	Yes = 10,
	NotApplicable = 20,
}
